export interface FaqItem {
  q: string;
  a: string;
}

export const homeFaqs: FaqItem[] = [
  {
    q: "网红黑曝是怎么一步步发酵扩散的？",
    a: "绝大多数事件都遵循四段式路径：先在私域社群或垂直社区出现原始素材，随后被搬运号加工成便于转发的形式，话题量突破平台阈值后进入热搜，最后跨平台扩散并进入长尾。真正决定事件规模的，是第二步加工得是否足够「低门槛」。",
  },
  {
    q: "热搜上的位置能代表真实热度吗？",
    a: "只能部分代表。榜单展示的是某个时间切片的相对位置，会受同期其他话题、平台规则和发布时段影响。我们建议同时看话题量的绝对值、转发增速和跨平台跳转节点，三者结合才更接近真实传播规模。",
  },
  {
    q: "为什么有些事件看起来很快就不热了？",
    a: "通常是三个原因：一是缺少对抗性情节，双方口径一致导致没有新素材；二是爆发时段在深夜，热度被拆散成两段；三是当事人给出了足够具体的回应，讨论失去了继续追问的空间。",
  },
  {
    q: "热度走势图里的百分比代表什么？",
    a: "它表示当前观测窗口内的相对热度，以该事件自身热度峰值折算为 100。这样不同规模的事件可以放在同一张图里对比曲线形状，而不是被绝对数值差淹没。",
  },
  {
    q: "你们会收录哪些类型的事件？",
    a: "目前主要覆盖五个方向：商业争议、带货翻车、人设崩塌、情感纠纷与网红言论。判断标准是事件是否形成了可观测的传播链路，单纯的观点表达或未形成扩散讨论的内容暂不纳入。",
  },
  {
    q: "追踪数据多久更新一次？",
    a: "处于发酵期的热点事件我们按小时级别观察热度变化，已经进入长尾的事件会降低频率。如果你订阅了追踪简报，会在每天固定时段收到一次此前二十四小时的走势汇总。",
  },
  {
    q: "你们会对事件下结论吗？",
    a: "不会。瓜链只做传播层面的记录与结构化呈现，不判断是非、不评价当事人。页面中出现的时间线、渠道占比和解读文字，目的都是帮助读者理解信息怎么流动，而不是给出立场。",
  },
];

export const aboutFaqs: FaqItem[] = [
  {
    q: "瓜链和普通的娱乐资讯站有什么区别？",
    a: "普通资讯站关注「发生了什么」，我们更关注「它是怎么传播开的」。同一个事件在我们的页面里会被拆解成热度序列、扩散渠道与发酵节点，读者看到的不只是结论，还有结论形成的过程。",
  },
  {
    q: "内容是谁整理的？",
    a: "由编辑团队按统一的观察口径整理，每条事件都记录了首爆时间、首爆平台与关键跳转节点。我们尽量保留信源时间戳，方便读者自行核对传播顺序。",
  },
];